import { DoubleAuthentificationResponse } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { otpQueryKeys } from "../query-keys/double-authentification.query-keys";

export const generateSecretDoubleAuthentification = async (
  emailOrConnectId?: string
) => {
  const { data } = await privateAxios.get<DoubleAuthentificationResponse>(
    `/otp/generate`,
    {
      params: {
        emailOrConnectId,
      },
    }
  );
  return data;
};

export const useGenerateSecretDoubleAuthentification = (
  isEnabled: boolean,
  emailOrConnectId?: string
) => {
  return useQuery({
    queryKey:
      otpQueryKeys.generateSecretDoubleAuthentification(emailOrConnectId),
    queryFn: () => generateSecretDoubleAuthentification(emailOrConnectId),
    enabled: isEnabled && emailOrConnectId !== undefined,
  });
};
